export const loopArray = ( items, callback, extraData = {} ) => {
	if ( ! items || ! items.length ) {
		return
	}

	return items.map( ( item, index ) => {
		return callback( index, item, extraData )
	} )
}
